type IdiomaIntegracao = "pt" | "en" | "es" | "zh-CN";

const pt = [
  "Configuração TEF",
  "Configuração Fiscal",
  "Configure o e-SiTef por empresa. As credenciais são criptografadas e usadas somente pelo backend.",
  "Configure a Focus NFe por empresa para NFe, NFCe e NFSe, mantendo o token exclusivamente no backend.",
  "Testar conexão",
  "Conexão concluída e credenciais aceitas pelo provedor.",
  "O provedor recusou as credenciais configuradas.",
  "O provedor respondeu e aceitou a autenticação.",
  "O provedor respondeu, mas não foi possível validar completamente as credenciais.",
  "O provedor não respondeu dentro do tempo configurado.",
  "Não foi possível alcançar o provedor.",
  "Não foi possível conectar ao servidor.",
  "Não foi possível concluir a operação.",
  "Não foi possível carregar a configuração TEF.",
  "Não foi possível salvar a configuração TEF.",
  "Não foi possível testar a conexão TEF.",
  "Não foi possível carregar a configuração Fiscal.",
  "Não foi possível salvar a configuração Fiscal.",
  "Não foi possível testar a conexão Fiscal.",
  "Configuração TEF salva com segurança.",
  "Configuração Fiscal salva com segurança.",
  "Operação",
  "Operação fiscal",
  "A ativação vale somente para a organização e empresa selecionadas no topo.",
  "Ativar TEF para esta empresa",
  "Usar confirmação tardia",
  "Ativar Fiscal para esta empresa",
  "Ambiente e-SiTef",
  "Ambiente Focus NFe",
  "Homologação (testes)",
  "Produção",
  "Endpoint controlado pelo backend",
  "Credenciais Software Express",
  "Campos em branco mantêm as credenciais já salvas.",
  "Credencial configurada; digite somente para substituir",
  "Credencial protegida e configurada no backend",
  "Credencial ainda não configurada",
  "Novo Merchant ID",
  "Informe o Merchant ID",
  "Nova Merchant Key",
  "Informe a Merchant Key",
  "Novo código da empresa",
  "Novo identificador do terminal",
  "Opcional; conforme habilitação no e-SiTef",
  "Resiliência",
  "Limites usados pelo backend nas consultas e reconciliações.",
  "Tempo limite em milissegundos",
  "Tentativas de consulta",
  "O React não recebe credenciais salvas nem dados de cartão. Pagamentos serão iniciados e consultados pelo servidor.",
  "Carregando configuração TEF...",
  "Autenticação Focus NFe",
  "O token de homologação é diferente do token de produção.",
  "Novo token Focus NFe",
  "Cole o token da Focus NFe",
  "Prefixo da referência fiscal",
  "Séries fiscais",
  "Confirme as séries com a contabilidade antes de emitir em produção.",
  "Série NFe",
  "Série NFCe",
  "Série NFSe",
  "O React recebe apenas o estado da configuração. O token e as chamadas fiscais permanecem no servidor.",
  "Carregando configuração Fiscal...",
  "Selecione uma organização antes de configurar a integração.",
  "Selecione uma empresa antes de configurar a integração.",
  "Organização ou empresa selecionada inválida.",
  "A empresa selecionada não pertence à organização atual.",
  "Acesso às configurações não permitido.",
  "Informe Merchant ID e Merchant Key antes de ativar o TEF.",
  "Informe o token da Focus NFe antes de ativar o Fiscal.",
  "Ative ao menos um documento fiscal.",
  "O prefixo fiscal deve conter apenas letras e números.",
] as const;

const translations: Record<Exclude<IdiomaIntegracao, "pt">, readonly string[]> = {
  en: [
    "TEF Configuration", "Fiscal Configuration",
    "Configure e-SiTef per company. Credentials are encrypted and used only by the backend.",
    "Configure Focus NFe per company for NFe, NFCe and NFSe while keeping the token exclusively in the backend.",
    "Test connection", "Connection completed and credentials accepted by the provider.",
    "The provider rejected the configured credentials.", "The provider responded and accepted authentication.",
    "The provider responded, but the credentials could not be fully validated.",
    "The provider did not respond within the configured timeout.", "The provider could not be reached.",
    "Could not connect to the server.", "The operation could not be completed.",
    "The TEF configuration could not be loaded.", "The TEF configuration could not be saved.",
    "The TEF connection could not be tested.", "The Fiscal configuration could not be loaded.",
    "The Fiscal configuration could not be saved.", "The Fiscal connection could not be tested.",
    "TEF configuration saved securely.", "Fiscal configuration saved securely.", "Operation", "Fiscal operation",
    "Activation applies only to the organization and company selected at the top.",
    "Enable TEF for this company", "Use delayed confirmation", "Enable Fiscal for this company",
    "e-SiTef environment", "Focus NFe environment", "Certification (tests)", "Production",
    "Backend-controlled endpoint", "Software Express credentials",
    "Blank fields keep the credentials already saved.", "Credential configured; type only to replace it",
    "Credential protected and configured in the backend", "Credential not configured yet",
    "New Merchant ID", "Enter the Merchant ID", "New Merchant Key", "Enter the Merchant Key",
    "New company code", "New terminal identifier", "Optional; according to e-SiTef enablement",
    "Resilience", "Limits used by the backend for queries and reconciliation.",
    "Timeout in milliseconds", "Query attempts",
    "React does not receive saved credentials or card data. Payments will be initiated and queried by the server.",
    "Loading TEF configuration...", "Focus NFe authentication",
    "The certification token is different from the production token.", "New Focus NFe token",
    "Paste the Focus NFe token", "Fiscal reference prefix", "Fiscal series",
    "Confirm the series with accounting before issuing in production.",
    "NFe series", "NFCe series", "NFSe series",
    "React receives only the configuration status. The token and fiscal calls remain on the server.",
    "Loading Fiscal configuration...", "Select an organization before configuring the integration.",
    "Select a company before configuring the integration.", "The selected organization or company is invalid.",
    "The selected company does not belong to the current organization.", "Configuration access is not allowed.",
    "Enter the Merchant ID and Merchant Key before enabling TEF.",
    "Enter the Focus NFe token before enabling Fiscal.", "Enable at least one fiscal document.",
    "The fiscal prefix must contain only letters and numbers.",
  ],
  es: [
    "Configuración TEF", "Configuración Fiscal",
    "Configure e-SiTef por empresa. Las credenciales se cifran y solo las utiliza el backend.",
    "Configure Focus NFe por empresa para NFe, NFCe y NFSe, manteniendo el token exclusivamente en el backend.",
    "Probar conexión", "Conexión completada y credenciales aceptadas por el proveedor.",
    "El proveedor rechazó las credenciales configuradas.", "El proveedor respondió y aceptó la autenticación.",
    "El proveedor respondió, pero no fue posible validar completamente las credenciales.",
    "El proveedor no respondió dentro del tiempo configurado.", "No fue posible comunicarse con el proveedor.",
    "No fue posible conectar con el servidor.", "No fue posible completar la operación.",
    "No fue posible cargar la configuración TEF.", "No fue posible guardar la configuración TEF.",
    "No fue posible probar la conexión TEF.", "No fue posible cargar la configuración Fiscal.",
    "No fue posible guardar la configuración Fiscal.", "No fue posible probar la conexión Fiscal.",
    "Configuración TEF guardada de forma segura.", "Configuración Fiscal guardada de forma segura.",
    "Operación", "Operación fiscal",
    "La activación se aplica solo a la organización y empresa seleccionadas arriba.",
    "Activar TEF para esta empresa", "Usar confirmación diferida", "Activar Fiscal para esta empresa",
    "Entorno e-SiTef", "Entorno Focus NFe", "Homologación (pruebas)", "Producción",
    "Endpoint controlado por el backend", "Credenciales Software Express",
    "Los campos vacíos conservan las credenciales ya guardadas.",
    "Credencial configurada; escriba solo para reemplazarla",
    "Credencial protegida y configurada en el backend", "Credencial aún no configurada",
    "Nuevo Merchant ID", "Ingrese el Merchant ID", "Nueva Merchant Key", "Ingrese la Merchant Key",
    "Nuevo código de empresa", "Nuevo identificador del terminal",
    "Opcional; según la habilitación en e-SiTef", "Resiliencia",
    "Límites usados por el backend en consultas y conciliaciones.",
    "Tiempo límite en milisegundos", "Intentos de consulta",
    "React no recibe credenciales guardadas ni datos de tarjeta. Los pagos serán iniciados y consultados por el servidor.",
    "Cargando configuración TEF...", "Autenticación Focus NFe",
    "El token de homologación es diferente del token de producción.", "Nuevo token Focus NFe",
    "Pegue el token de Focus NFe", "Prefijo de referencia fiscal", "Series fiscales",
    "Confirme las series con contabilidad antes de emitir en producción.",
    "Serie NFe", "Serie NFCe", "Serie NFSe",
    "React recibe solo el estado de la configuración. El token y las llamadas fiscales permanecen en el servidor.",
    "Cargando configuración Fiscal...", "Seleccione una organización antes de configurar la integración.",
    "Seleccione una empresa antes de configurar la integración.",
    "La organización o empresa seleccionada no es válida.",
    "La empresa seleccionada no pertenece a la organización actual.",
    "No se permite el acceso a las configuraciones.",
    "Ingrese Merchant ID y Merchant Key antes de activar TEF.",
    "Ingrese el token de Focus NFe antes de activar Fiscal.", "Active al menos un documento fiscal.",
    "El prefijo fiscal debe contener solo letras y números.",
  ],
  "zh-CN": [
    "TEF 配置", "财税配置",
    "按公司配置 e-SiTef。凭据经过加密且仅由后端使用。",
    "按公司配置 Focus NFe 的 NFe、NFCe 和 NFSe，并将令牌仅保留在后端。",
    "测试连接", "连接成功，提供商已接受凭据。", "提供商拒绝了已配置的凭据。",
    "提供商已响应并接受身份验证。", "提供商已响应，但无法完全验证凭据。",
    "提供商未在配置的时间内响应。", "无法连接到提供商。", "无法连接到服务器。",
    "无法完成操作。", "无法加载 TEF 配置。", "无法保存 TEF 配置。", "无法测试 TEF 连接。",
    "无法加载财税配置。", "无法保存财税配置。", "无法测试财税连接。",
    "TEF 配置已安全保存。", "财税配置已安全保存。", "运行设置", "财税运行设置",
    "启用设置仅适用于顶部所选的组织和公司。", "为此公司启用 TEF", "使用延迟确认",
    "为此公司启用财税模块", "e-SiTef 环境", "Focus NFe 环境", "认证环境（测试）", "生产环境",
    "由后端控制的端点", "Software Express 凭据", "留空字段将保留已保存的凭据。",
    "凭据已配置；仅在替换时输入", "凭据已在后端受保护并完成配置", "凭据尚未配置",
    "新 Merchant ID", "请输入 Merchant ID", "新 Merchant Key", "请输入 Merchant Key",
    "新公司代码", "新终端标识符", "可选；取决于 e-SiTef 的开通设置", "弹性设置",
    "后端查询和对账所使用的限制。", "超时时间（毫秒）", "查询重试次数",
    "React 不会接收已保存的凭据或银行卡数据。付款由服务器发起和查询。",
    "正在加载 TEF 配置…", "Focus NFe 身份验证", "认证环境令牌与生产环境令牌不同。",
    "新 Focus NFe 令牌", "粘贴 Focus NFe 令牌", "财税引用前缀", "财税序列",
    "在生产环境开票前，请与会计确认序列。", "NFe 序列", "NFCe 序列", "NFSe 序列",
    "React 仅接收配置状态。令牌和财税调用均保留在服务器。",
    "正在加载财税配置…", "配置集成前请选择组织。", "配置集成前请选择公司。",
    "所选组织或公司无效。", "所选公司不属于当前组织。", "不允许访问配置。",
    "启用 TEF 前请输入 Merchant ID 和 Merchant Key。", "启用财税模块前请输入 Focus NFe 令牌。",
    "请至少启用一种财税单据。", "财税前缀只能包含字母和数字。",
  ],
};

function dictionary(language: IdiomaIntegracao): Record<string, string> {
  if (language === "pt") return Object.fromEntries(pt.map((key) => [key, key]));
  return Object.fromEntries(pt.map((key, index) => [key, translations[language][index] || key]));
}

export const TEXTOS_INTEGRACOES_ERP: Record<IdiomaIntegracao, Record<string, string>> = {
  pt: dictionary("pt"),
  en: dictionary("en"),
  es: dictionary("es"),
  "zh-CN": dictionary("zh-CN"),
};
